import styles from './VideoDescription.module.css';

const VideoDescription = ({ description }: { description: string }) => {
  return <p className={styles.description}>{description}</p>;
};

export default VideoDescription;
